/**
 * Application Entry Point
 * Dynamically imports bootstrap to ensure Module Federation shared modules initialize first
 */

import('./bootstrap').catch(err => {
  console.error('Failed to load application:', err);
});
